export const BLOG_FETCH_REQUEST = "BLOG_FETCH_REQUEST"
export const BLOG_FETCH_SUCCESS = "BLOG_FETCH_SUCCESS"
export const BLOG_FETCH_FAIL = "BLOG_FETCH_FAIL"

export const BLOG_DETAILS_REQUEST = "BLOG_DETAILS_REQUEST"
export const BLOG_DETAILS_SUCCESS = "BLOG_DETAILS_SUCCESS"
export const BLOG_DETAILS_FAIL = "BLOG_DETAILS_FAIL"


export const BLOG_CREATE_REQUEST = "BLOG_CREATE_REQUEST"
export const BLOG_CREATE_SUCCESS = "BLOG_CREATE_SUCCESS"
export const BLOG_CREATE_FAIL = "BLOG_CREATE_FAIL"